export default (search = '') =>
  search
    .replace('?', '')
    .split('&')
    .reduce((r, c) => {
      const [key, value] = c.split('=');
      return Object.assign(r, { [key]: value });
    }, {});
